



import React, { useRef, useState } from 'react';

import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png"
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';

import { useNavigate } from 'react-router-dom';
import { goBack, isEmpty } from '../../../Utils/common';

import { formValidation } from '../../../Utils/formValidation';
import PictureUpload from '../../../components/PictureUpload/PictureUpload';
import { ButtonWrapper } from '../../../components/ui/style';
import photoCapturIcon from "../../../images/photo-capture.svg";
import Webcam from 'react-webcam';
import TakeImage from '../../../components/TakeImage/TakeImage';

import { BadgeCheck } from "lucide-react";

const initialData = {
  pinCode: "",
  city: "",
  state: "",
  landmark: "",
  address2: "",
  address1: "",
  residenceType: "",
}


function Ekyc() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [responce, setResponce] = useState({});
  const [formData, setFormData] = useState(initialData);
  const [formDataError, setFormDataError] = useState(initialData);
  const [openCamera, setOpenCamera] = useState(false)
  const [aadharFront, setAadharFront] = useState("");
  const [aadharBack, setAadharBack] = useState("");

  const navigate = useNavigate();




  const submit = () => {


    const error = formValidation(formData);

    setFormDataError({ ...formDataError, ...error });
    const param = {

    }

    if (isEmpty(error)) {
      setLoading(true);
      //     verifyPan(param).then(resp=>{
      //     setLoading(false);
      //     console.log(resp?.data)
      //     if(resp?.data?.Status === 1){
      //       setResponce(resp?.data);
      //       setMessage({ type: 'success', msg:resp?.data?.Message, place:"globle" });
      //     }else{
      //       setMessage({ type: 'error', msg: resp?.data?.Message, });
      //     }


      // })

    }


  }




  return (
    // <BoxWrapper className="w100" >


    //   <div className="formmainBox flex">
    //     <div className="left">
    //       <div className='center gap4 pointer' onClick={() => goBack(navigate, "/my-dashboard/eligibility")} >
    //         <img src={arrowIcon} alt="" /> <span>Back</span>
    //       </div>
    //     </div>
    //     <div className="right">
    //       <h2>Complate Your KYC</h2>
    //       <p>Upload you document and complete the kyc.</p>

    //       <FormWrapper>
    //         <Alert setMessage={setMessage} message={message} />

    //         <div className="inputBox">
    //           <div >
    //             <h2 className='subheading small'>Aadhar front side</h2>
    //             <PictureUpload setImage={setAadharFront} image={aadharFront} />

    //           </div>
    //           <div>
    //             <h2 className='subheading small'>Aadhar back side</h2>
    //             <PictureUpload setImage={setAadharBack} image={aadharBack} />

    //           </div>
    //         </div>



    //         <div className="button">
    //           <Button title="Continue" onClick={submit} loading={loading} />
    //         </div>
    //       </FormWrapper>

    //     </div>
    //   </div>

    // </BoxWrapper>

    <BoxWrapper className="w-full min-h-screen bg-gray-100 p-3 sm:p-5 md:p-8">

      <div className="flex flex-col gap-5">

        {/* Back Button */}
        <div
          className="inline-flex w-fit items-center gap-2 border border-gray-300 rounded-xl px-5 py-3 cursor-pointer bg-white hover:bg-gray-50 transition-all duration-300"
          onClick={() => goBack(navigate, "/my-dashboard/eligibility")}
        >
          <img
            src={arrowIcon}
            alt=""
            className="w-4 transition-transform duration-300 group-hover:-translate-x-1"
          />
          <span className="font-medium text-black">Back</span>
        </div>

        {/* Main Card */}
        <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-5 sm:p-8 md:p-10">

          {/* Header */}
          <div className="text-center mb-8">

            <div className="flex justify-center mb-5">
              <div className="flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-2xl bg-[#EEF6FF] border border-blue-100 shadow-sm">
                <BadgeCheck className="h-8 w-8 sm:h-10 sm:w-10 text-[#2D5F7A]" />
              </div>
            </div>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#1D3557]">
              Complate Your KYC
            </h2>

            <p className="mt-2 text-sm sm:text-base text-gray-500">
              Upload you document and complete the kyc.
            </p>

          </div>

          <FormWrapper>

            <Alert
              setMessage={setMessage}
              message={message}
            />

            {/* Upload Documents */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              <div>
                <h2 className="text-lg font-semibold text-[#1D3557] mb-3">
                  Aadhar front side
                </h2>

                <PictureUpload
                  setImage={setAadharFront}
                  image={aadharFront}
                />
              </div>

              <div>
                <h2 className="text-lg font-semibold text-[#1D3557] mb-3">
                  Aadhar back side
                </h2>

                <PictureUpload
                  setImage={setAadharBack}
                  image={aadharBack}
                />
              </div>

            </div>

            {/* Security Notice */}
            <div className="mt-8 flex items-start gap-4 rounded-2xl border border-green-200 bg-green-50 p-5">

              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow shrink-0">
                🔒
              </div>

              <div>
                <h4 className="font-semibold text-[#1D3557]">
                  Your documents are safe with us
                </h4>

                <p className="mt-1 text-sm text-gray-600">
                  Your Aadhaar documents are encrypted and securely used only for KYC verification.
                </p>
              </div>

            </div>

            {/* Continue Button */}
            <div className="mt-8">
              <Button
                className="w-full bg-[#2D5F7A]"
                title="Continue"
                onClick={submit}
                loading={loading}
              />
            </div>

          </FormWrapper>

        </div>

      </div>

    </BoxWrapper>
  )
}

export default Ekyc;